const clearAllCaches = async () => {
  caches.keys().then((names) => {
    names.forEach((name) => {
      caches.delete(name);
    });
  });
  window.localStorage.clear();
  window.sessionStorage.clear();
};

export const clearAllCachesWithoutMedimoSettings = () => {
  const settings = window.localStorage.getItem("medimo-settings");
  clearAllCaches();
  if (settings) {
    window.localStorage.setItem("medimo-settings", settings);
  }
};
